// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5b71f5f","455":"431de835","977":"748869e6"}[chunkId] + ".chunk.js";
};